export default "__VITE_ASSET__C82xYw0D__"